module.exports = __webpack_public_path__ + "static/media/non-diver-btn-sc.7ddb3c7d.png";